import { Button as _Button, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const Button = styled(_Button)`
  border-radius: 50%;
  width: 112px;
  height: 112px;

  &&& svg {
    height: 56px;
    width: 56px;
  }

  ${mq.sp} {
    width: 56px;
    height: 56px;

    &&& svg {
      height: 28px;
      width: 28px;
    }
  }
`;
